export default "__VITE_ASSET__C64RvY07__"